<div *ngIf="isVisible()" class="payment-status-banner" [ngClass]="getBannerClass()">
  <mat-icon>{{ getIcon() }}</mat-icon>
  <span class="message">
    {{ getMessageKey() | translate }}
    <small *ngIf="getFailureMessage()" class="failure-reason">{{ getFailureMessage() }}</small>
  </span>
  <button
    *ngIf="shouldShowUpdateAction()"
    mat-stroked-button
    color="primary"
    (click)="updatePaymentMethod.emit()"
  >
    {{ getActionLabelKey() | translate }}
  </button>
</div>
